// extracted by mini-css-extract-plugin
export var dataCell = "_la-2";
export var dataRow = "_la-0";
export var headerRow = "_la-1";